<div class="alert alert-info m-4" role="alert">
  Welcome to the Client Portal, please wait while we load the Dashboard.
</div>
